import { useEffect } from "react";
import API from "../lib/api";

/**
 * Injects admin-managed ad codes with position="head" into document.head (for
 * ad-network verification tags, analytics, etc.) and position="footer" at the
 * end of document.body (for tracking pixels, chat widgets).
 * Re-creates <script> tags so they actually execute (innerHTML does not run scripts).
 */
export default function AdHeadInjector() {
  useEffect(() => {
    let mounted = true;
    const injectedNodes = [];

    const appendCode = (raw, target) => {
      if (!raw) return;
      const temp = document.createElement("div");
      temp.innerHTML = raw;
      Array.from(temp.childNodes).forEach((node) => {
        if (node.nodeType === 1 && node.tagName === "SCRIPT") {
          const s = document.createElement("script");
          Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          s.text = node.textContent || "";
          target.appendChild(s);
          injectedNodes.push(s);
        } else {
          const clone = node.cloneNode(true);
          if (node.nodeType === 1) {
            const nested = clone.querySelectorAll ? clone.querySelectorAll("script") : [];
            nested.forEach((orig) => {
              const s = document.createElement("script");
              Array.from(orig.attributes).forEach((a) => s.setAttribute(a.name, a.value));
              s.text = orig.textContent || "";
              orig.replaceWith(s);
            });
          }
          target.appendChild(clone);
          injectedNodes.push(clone);
        }
      });
    };

    API.get("/ads/codes")
      .then((r) => {
        if (!mounted) return;
        const codes = r.data.codes || [];
        codes
          .filter((c) => c.position === "head")
          .forEach((c) => appendCode(c.code, document.head));
        codes
          .filter((c) => c.position === "footer")
          .forEach((c) => appendCode(c.code, document.body));
      })
      .catch(() => {});

    return () => {
      mounted = false;
      injectedNodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    };
  }, []);

  return null;
}
